import { URLS } from "@app/shared";
import { PageHeader } from "@design-system/components";
import { Tabs } from "@modules/financial-information/components/tabs";
import { getCurrentLocaleCode, trans } from "@mongez/localization";
import { InvestmentCalculator } from "../components/InvestmentCalculator";
import { ShareGraph } from "../components/ShareGraph";
import { SharePriceAlerts } from "../components/SharePriceAlerts";
import { SharePriceLookUp } from "../components/SharePriceLookUp";
import { ShareSeries } from "../components/ShareSeries";
import { toolLocales } from "../utils";

export function ShareInformationPage() {
  const locale = getCurrentLocaleCode();
  const { standard } = toolLocales(locale);

  return (
    <>
      <PageHeader
        translationKey="shareInformation"
        breadcrumbItems={[
          { label: trans("home"), link: URLS.home },
          { label: trans("investorRelations"), link: URLS.investor.root },
          { label: trans("shareInformation") },
        ]}
      />
      <div className="bg-[#f7f9fc] py-12">
        <Tabs
          tabs={[
            {
              label: trans("shareGraph"),
              value: "shareGraph",
              component: () => <ShareGraph standard={standard} />,
            },
            {
              label: trans("shareSeries"),
              value: "shareSeries",
              component: () => <ShareSeries standard={standard} />,
            },
            {
              label: trans("sharePriceLookUp"),
              value: "sharePriceLookUp",
              component: () => <SharePriceLookUp standard={standard} />,
            },
            {
              label: trans("investmentCalculator"),
              value: "investmentCalculator",
              component: () => <InvestmentCalculator standard={standard} />,
            },
            {
              label: trans("sharePriceAlerts"),
              value: "sharePriceAlerts",
              component: () => <SharePriceAlerts standard={standard} />,
            },
          ]}
        />
      </div>
    </>
  );
}
